var months = [
    'Gen',
    'Feb',
    'Mar',
    'Apr',
    'Mag',
    'Giu',
    'Lug',
    'Ago',
    'Set',
    'Ott',
    'Nov',
    'Dic'
]

export const formatDate = (date) => {
    if (!date)
        return ''
    const d = date.getTime ? date : new Date(date)
    return [
        d.getDate(),
        months[d.getMonth()],
        d.getFullYear()
    ].join(' ')
}


// WEBPACK FOOTER //
// ./src/utils/formatDate.js